<template>
  <div>
    <v-dialog v-model="openModal" max-width="800">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12 text-center" v-show="!mostrarContenido">
              <v-progress-circular
                indeterminate
                color="primary"
                :size="100"
                :width="7"
              ></v-progress-circular>
            </v-col>
          </v-row>

          <v-row v-show="mostrarContenido">
            <v-col cols="12">
              <p class="text-center font-weight-bold">LISTA DE FAVORITOS</p>
            </v-col>

            <v-col cols="12" v-show="favoritos.length > 0">
              <v-simple-table class="tabla-favoritos">
                <thead>
                  <tr>
                    <th>ITEM</th>
                    <th class="px-15">CÓDIGO</th>
                    <th class="px-15">NOMBRE</th>
                    <th class="px-15">IMAGEN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(f, index) in favoritos" :key="index">
                    <td>
                      <p v-text="index + 1"></p>
                    </td>
                    <td>
                      <p v-if="f.producto != null" v-text="f.producto.codigo"></p>
                    </td>
                    <td>
                      <p v-if="f.producto != null" v-text="f.producto.nombre"></p>
                    </td>
                    <td class="text-center">
                      <img
                        v-if="f.producto != null && f.producto.imagenes.length > 0"
                        :src="assetAWS('monturas/' + f.producto.imagenes[0].nombre)"
                        width="30px"
                        height="25px"
                      />
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn class="mr-2" color="error" outlined="" @click="openModal = false">
                <v-icon left="">mdi-backspace</v-icon> Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openModal: false,
      idcliente: "",
      favoritos: [],
      mostrarContenido: false,
    };
  },
  props: {
    objModalFavoritos: {
      type: Object,
    },
  },
  watch: {
    objModalFavoritos(val) {
      this.openModal = val.openModal;
      this.idcliente = val.idcliente;
      this.favoritos = [];
      this.getFavoritos();
    },
  },

  methods: {
    getFavoritos() {
      this.mostrarContenido = false;
      this.axios({
        method: "POST",
        url: "api/panel/clientes/getFavoritos",
        data: {
          idcliente: this.idcliente,
        },
      })
        .then((response) => {
          const favoritos = response.data;
          this.favoritos = favoritos;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.mostrarContenido = true;
        });
    },
  },

  created() {},
};
</script>

<style scoped>
.tabla-favoritos {
  width: 100% !important;
  border-collapse: collapse;
  border-spacing: 0;
}

.tabla-favoritos thead tr th {
  white-space: nowrap !important;
  font-size: 12px;
  border: 1px solid silver;
  padding-left: 5px;
  padding-right: 5px;
}

.tabla-favoritos tbody tr td {
  white-space: nowrap !important;
  border: 1px solid silver;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
